import { Chip, CircularProgress, makeStyles } from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';
import React from 'react'
import { CustomTextField } from '..';

const useStyles = makeStyles((theme) => ({
    input: {
        fontSize: '1rem!important'
    },
}));

function AutocompleteSearch(props) {
    const classes = useStyles();

    const {
        selectedOptions,
        multiple,
        label,
        placeholder,
        onChange,
        loading,
        ...remainingProps
    } = props;

    return (
        <Autocomplete
            id="autocomplete-search"
            getOptionLabel={(option) => option.name}
            value={(multiple) ? selectedOptions : (selectedOptions?.[0] ?? null)}
            renderTags={(tagValue, getTagProps) =>
                tagValue.map((option, index) => (
                    <Chip
                        label={option.name}
                        {...getTagProps({ index })}
                    />
                ))
            }
            renderInput={(params) => (
                <CustomTextField
                    {...params}
                    label={label}
                    placeholder={placeholder}
                    InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                            <>
                                {loading ? <CircularProgress color='inherit' size={20} /> : null}
                                {params.InputProps.endAdornment}
                            </>
                        )
                    }}
                />
            )}
            classes={{
                input: classes.input,
                listbox: classes.input
            }}
            {...remainingProps}
            onChange={(event, newSelectedOptions) => {
                const newSelectedOptionsArray = (
                    (multiple)
                        ? newSelectedOptions
                        : [newSelectedOptions]
                )
                if (onChange) onChange(
                    event, newSelectedOptionsArray
                )
            }}
        />
    );
}

export default AutocompleteSearch